import { ListChecks } from "lucide-react";

const manifest = {
  key: "work_classification_management",
  isFreeModule: true,
  isPurchasable: false,
  icon: ListChecks,
  names: {
    plan: {
      en: "Work Classification Management",
      ar: "\u0625\u062f\u0627\u0631\u0629 \u062a\u0635\u0646\u064a\u0641 \u0645\u062c\u0627\u0644\u0627\u062a \u0627\u0644\u0639\u0645\u0644",
      "zh-Hans": "工作领域分类管理",
    },
    dashboard: {
      en: "Work Classification Management",
      ar: "\u0625\u062f\u0627\u0631\u0629 \u062a\u0635\u0646\u064a\u0641 \u0645\u062c\u0627\u0644\u0627\u062a \u0627\u0644\u0639\u0645\u0644",
      "zh-Hans": "工作领域分类管理",
    },
  },
  defaultPath: "/work-classification-management",
  matchers: [
    /^\/work-classification-management(?:\/|$)/,
    /^\/field-of-work-classification(?:\/|$)/,
  ],
  buildNavbarMenus: ({ activeModuleLabel }) => [
    {
      label: activeModuleLabel,
      path: "/work-classification-management",
    },
  ],
};

export default manifest;
